import React from 'react';
import { useTranslation } from 'next-i18next';
import { w as withProviders } from '../../withProviders-l3mjYkR2.js';
import 'react-i18next';
import 'notistack';
import '../../context/index.js';

const Banner = () => {
    const { t: tAccor } = useTranslation('', { keyPrefix: '$accorCommon' });
    return (React.createElement("div", { className: "above-promo earn-burn", role: "complementary", "aria-label": "Rewards Information" },
        React.createElement("div", { className: "container" },
            React.createElement("span", { className: "icon-all" }),
            React.createElement("strong", { dangerouslySetInnerHTML: { __html: tAccor('allBanner') } }))));
};
var AllBanner = withProviders(Banner, { translation: true });

export { AllBanner };
//# sourceMappingURL=index.js.map
